module.exports = __webpack_public_path__ + "img/20200606_153324.aceb3e3e.jpg";